import CryptoJS from "crypto-js";

const cryptoKey = process.env.REACT_APP_CRYPTO_KEY;
const cryptoIv = process.env.REACT_APP_CRYPTO_IV;

if (!cryptoKey || !cryptoIv) {
  throw new Error(
    "Missing REACT_APP_CRYPTO_KEY or REACT_APP_CRYPTO_IV in environment variables"
  );
}

const key = CryptoJS.enc.Utf8.parse(cryptoKey); // 32 bytes
const iv = CryptoJS.enc.Utf8.parse(cryptoIv); // 16 bytes

export function encryptCredential(detail: string): string {
  const encrypted = CryptoJS.AES.encrypt(detail, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}
